// ✅ config.js
// Définit la bonne base API pour localhost et production

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3001/api"
    : "https://live-evo.com/api";

// URL des fichiers uploadés (images, vidéos, etc.)
const UPLOADS_URL = `${API_BASE_URL.replace("/api", "")}/uploads`;

// 👉 On exporte à la fois en default ET en named
export default API_BASE_URL;
export { API_BASE_URL, UPLOADS_URL };
